import tableStyle from '../../Table.module.css';

/**
 * Styling component for cells that contain an input. 
 * Aligns it's children to the center.
 */
const Input = ({ colSpan = 1, className = '', style = undefined, children }) => (
  <td className={[tableStyle.Input, className].join(' ')} style={style} colSpan={colSpan}>
    <div className={tableStyle.Flex}>
      {children}
    </div>
  </td>
);

/**
 * Styling component for cells that contain action buttons. 
 * Aligns it's children to the right.
 */
const Action = ({ colSpan = 1, className = '', style = undefined, children }) => (
  <td className={[tableStyle.Action, className].join(' ')} style={style} colSpan={colSpan}>
    <div className={tableStyle.Flex}>
      {children}
    </div>
  </td>
);

/**
 * Styling component for cells with multiline text. 
 * Truncates text that exceeds the maxWidth and displays a tooltip on hover.
 * @param {String} maxWidth the maximum width before text is truncated, i.e. '10vw' (CANNOT be a percentage)
 */
const Multiline = ({ maxWidth, colSpan = 1, className = '', style = undefined, children }) => (
  <td className={[tableStyle.Multiline, className].join(' ')} style={style} colSpan={colSpan}>
    <div title={String(children)} style={{ maxWidth }}>
      {children}
    </div>
  </td>
);

export { Multiline, Action, Input };